import React from 'react'
import { ContentHeader } from '../../../layout/Content'

function POItemHeader() { return ( <ContentHeader title='Purchase Order Items'/> ) }

export default React.memo(POItemHeader)
